import { render, staticRenderFns } from "./EditCoach.vue?vue&type=template&id=251d5c8c"
import script from "./EditCoach.vue?vue&type=script&lang=js"
export * from "./EditCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports